const Ajax = require('common/infra/ajax');

class API {
    getElements(projectID, diagramID, dt) {
        // クエリパラメータで records, relations のどちらor両方を返すか指定できるようにする
        let path = `/api/projects/${projectID}/diagrams/${diagramID}/elements`;
        let queries = [];
        if (dt) {
            queries.push(`dt=${dt}`);
        }
        if (queries.length > 0) {
            path += '?' + queries.join('&');
        }

        return Ajax.GET(path);
    }

    getRecordsByPartial(projectID, dt, recordIDs) {
        let path =`/api/projects/${projectID}/records`;
        let queries = _.map(recordIDs, (id) => { return `id=${id}`; });

        if (dt) {
            queries.push(`dt=${dt}`);
        }
        if (queries.length > 0) {
            path += '?' + queries.join('&');
        }

        return Ajax.GET(path);
    }

    getRelationsByPartial(projectID, dt, relationIDs) {
        let path =`/api/projects/${projectID}/relations`;
        let queries = _.map(relationIDs, (id) => { return `id=${id}`; });

        if (dt) {
            queries.push(`dt=${dt}`);
        }
        if (queries.length > 0) {
            path += '?' + queries.join('&');
        }

        return Ajax.GET(path);
    }

    updateElements(projectID, diagramID, elementsJSON) {
        let path = `/api/projects/${projectID}/diagrams/${diagramID}/elements`;
        return Ajax.PUT(path, elementsJSON);
    }

    getNode(projectID, recordID, dt) {
        let path = `/api/projects/${projectID}/records/${recordID}`;
        if(dt) {
            path += `?dt=${dt}`;
        }
        return Ajax.GET(path);
    }

    getLink(projectID, relationID, dt) {
        let path = `/api/projects/${projectID}/relations/${relationID}`;
        if(dt) {
            path += `?dt=${dt}`;
        }
        return Ajax.GET(path);
    }

    updateLink(projectID, relationID, relationJSON) {
        let path = `/api/projects/${projectID}/relations/${relationID}`;
        return Ajax.PUT(path, relationJSON);
    }

    getRemoteLinks(projectID, diagramID, dt) {
        let path = `/api/projects/${projectID}/diagrams/${diagramID}/remote-links`;
        if(dt) {
            path += `?dt=${dt}`;
        }
        return Ajax.GET(path);
    }

    getValueTypes(projectID, dt, types) {
        let path = `/api/projects/${projectID}/value-types`;
        if(dt) {
            path += `?dt=${dt}`;
        }
        return Ajax.POST(path);
    }

}

module.exports = new API();



// WEBPACK FOOTER //
// ./system/infra/api/element.js